import { render, staticRenderFns } from "./sharePeople.vue?vue&type=template&id=126f6789&scoped=true&"
import script from "./sharePeople.vue?vue&type=script&lang=js&"
export * from "./sharePeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126f6789",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126f6789')) {
      api.createRecord('126f6789', component.options)
    } else {
      api.reload('126f6789', component.options)
    }
    module.hot.accept("./sharePeople.vue?vue&type=template&id=126f6789&scoped=true&", function () {
      api.rerender('126f6789', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/list/sharePeople.vue"
export default component.exports